import { render, staticRenderFns } from "./Bmap.vue?vue&type=template&id=18a42b25&"
import script from "./Bmap.vue?vue&type=script&lang=js&"
export * from "./Bmap.vue?vue&type=script&lang=js&"
import style0 from "./Bmap.vue?vue&type=style&index=0&id=18a42b25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports